import { useMemo, type ReactNode } from 'react';
import { TableCellCommentShell } from './TableCellCommentShell';
import './ProjectTableCellCommentShell.css';

interface ReaderTableCellCommentShellProps {
  readerPersonId: string;
  readerName: string;
  columnId: string;
  commentCount: number;
  children: ReactNode;
}

export function ReaderTableCellCommentShell({
  readerPersonId,
  readerName,
  columnId,
  commentCount,
  children,
}: ReaderTableCellCommentShellProps) {
  const readerTarget = useMemo(
    () =>
      ({ kind: 'reader' as const, readerPersonId, readerName, columnId }),
    [readerPersonId, readerName, columnId]
  );

  return (
    <TableCellCommentShell target={readerTarget} commentCount={commentCount}>
      {children}
    </TableCellCommentShell>
  );
}
